<template>
    <div class="form-rate">
        <form action="" @submit.prevent="handleSubmit" class="relative">
            <div class="form__head">
                <h2 class="h1">Valuta questo libro</h2>
            </div>

            <div class="form__body">
                <div class="form__row form-rate__rating">
                    <star-rating
                        :increment="1"
                        :star-size="32"
                        inactive-color="transparent"
                        active-color="#7C37FA"
                        border-color="#7C37FA"
                        :border-width="1"
                        :rounded-corners="true"
                        :star-points="[23,5, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                        @update:rating ="setRating"
                    />
                </div>

                <div class="form__row">
                    <textarea
                        name="rate-comment"
                        id="rate-comment"
                        v-model="form.comment"
                        placeholder="Aggiungi una recensione scritta"
                        :maxlength="maxChars"
                        class="form__textarea"
                    ></textarea>

                    <p>
                        {{form.comment.length}} / {{maxChars}}
                    </p>
                </div>

                <div class="form__row form-rate__switch">
                    <switch-toggle
                        :values="switchOptions"
                        :defaultChecked="true"
                        @on-change="val => setSwitch(val)"
                    />
                </div>
            </div>

            <div class="form__actions">
                <button type="button"  @click="handleCancel" class="form__btn btn btn--outlined-primary">
                    Annulla
                </button>

                <button type="submit" class="form__btn btn btn--primary">
                    Pubblica
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { ref } from 'vue';
import BaseInput from '@/components/base-input/base-input';
import StarRating from 'vue-star-rating';
import SwitchToggle from '@/components/switch-toggle/switch-toggle';

export default {
    name: 'FormRate',

    components: {
        BaseInput,
        StarRating,
        SwitchToggle,
    },

    setup(_ , { emit }) {
        const form = ref({
            comment: '',
            rating: 0,
            commentFor: 1
        });

        const maxChars = ref(500)
        const switchOptions = ref(['Libro personale', 'Libro biblioteca'])

        const handleSubmit = () => {
            emit('on-submit', form.value);
        };

        const handleCancel = () => {
            emit('on-cancel');
        }

        const setRating = rating => {
            form.value.rating = rating;
        }

        const setSwitch = val => {
            form.value.commentFor = +val
        }

        return {
            form,
            maxChars,
            handleSubmit,
            handleCancel,
            setRating,
            switchOptions,
            setSwitch
        }
}

}
</script>

<style>

</style>
